<template>
  <div class="latin-america">
    <top-section />
    <!-- <current-population /> -->
    <facts-about />

    <latin-america-market-potential />
    <latin-america-top-five />
    <latin-america-gdp />
    <about-section />

    <faq-block bg-color-class="bg--color-01" />
    <subscribe-block />
  </div>
</template>

<script>
export default {
  name: 'LatinAmerica',
  components: {
    TopSection: () => import('@/components/latin-america/TopSection.vue'),
    // CurrentPopulation: () => import('@/components/latin-america/CurrentPopulation.vue'),
    FactsAbout: () => import('@/components/latin-america/FactsAbout.vue'),

    LatinAmericaMarketPotential: () =>
      import('@/components/latin-america/LatinAmericaMarketPotential.vue'),
    LatinAmericaTopFive: () =>
      import('@/components/latin-america/LatinAmericaTopFive.vue'),
    LatinAmericaGdp: () =>
      import('@/components/latin-america/LatinAmericaGDP.vue'),
    AboutSection: () => import('@/components/latin-america/AboutSection.vue'),

    FaqBlock: () =>
      import(/* webpackMode: "eager" */ '@/components/welcome/FaqBlock.vue'),
    SubscribeBlock: () =>
      import(
        /* webpackMode: "eager" */ '@/components/welcome/SubscribeBlock.vue'
      ),
  },
}
</script>
